import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { FollowUp, FollowUpGet } from './api';

const initialState = {
  loading: false,
  completeFollowUpLoading: false,
  rescheduleFollowUpLoading: false
};

const actions = {
  CREATE_FOLLOW_UP: 'follow-up/CREATE_FOLLOW_UP',
  RESCHEDULE_FOLLOW_UP: 'follow-up/RESCHEDULE_FOLLOW_UP',
  COMPLETE_FOLLOW_UP: 'follow-up/COMPLETE_FOLLOW_UP',
  GET_FOLLOW_UP: 'follow-up/GET_FOLLOW_UP',
  GET_CATEGORIZED_FOLLOW_UP: 'follow-up/GET_CATEGORIZED_FOLLOW_UP'
};

export const createFollowUp = createAsyncThunk(
  actions.CREATE_FOLLOW_UP,
  async (payload) => {
    const response = await FollowUp('create-followup', payload);
    return response;
  }
);

export const rescheduleFollowUp = createAsyncThunk(
  actions.RESCHEDULE_FOLLOW_UP,
  async (payload) => {
    const response = await FollowUp('reschedule-followup', payload);
    return response;
  }
);

export const completeFollowUp = createAsyncThunk(
  actions.COMPLETE_FOLLOW_UP,
  async (payload) => {
    const response = await FollowUp('complete-followup', payload);
    return response;
  }
);

export const getFollowUps = createAsyncThunk(
  actions.GET_FOLLOW_UP,
  async (payload) => {
    const response = await FollowUpGet('get-followups', payload);
    return response;
  }
);

export const getCategorizedFollowUps = createAsyncThunk(
  actions.GET_CATEGORIZED_FOLLOW_UP,
  async (payload) => {
    const response = await FollowUpGet('categorized-followup', payload);
    return response;
  }
);

export const followUpSlice = createSlice({
  name: 'followUp',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createFollowUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFollowUp.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(createFollowUp.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(rescheduleFollowUp.pending, (state) => {
        state.rescheduleFollowUpLoading = true;
      })
      .addCase(rescheduleFollowUp.fulfilled, (state, action) => {
        state.rescheduleFollowUpLoading = false;

        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(rescheduleFollowUp.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.rescheduleFollowUpLoading = false;

        message.error(msg);
      });

    builder
      .addCase(completeFollowUp.pending, (state) => {
        state.completeFollowUpLoading = true;
      })
      .addCase(completeFollowUp.fulfilled, (state, action) => {
        state.completeFollowUpLoading = false;

        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(completeFollowUp.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.completeFollowUpLoading = false;

        message.error(msg);
      });

    builder
      .addCase(getFollowUps.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFollowUps.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getFollowUps.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getCategorizedFollowUps.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategorizedFollowUps.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getCategorizedFollowUps.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  }
});

export const selectFollowUpSlice = (state) => {
  return state.followUp;
};

export default followUpSlice.reducer;
